import { Component, OnInit } from '@angular/core';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent implements OnInit {
  isLoading: boolean = false;
  errors: any = {};
  registerForm = this.fb.group({
    name: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
    password: ['', [Validators.required, Validators.minLength(6)]],
    confirmPassword: ['', [Validators.required]]
  }, { validator: this.passwordMatchValidator });

  constructor(private fb: FormBuilder, 
    private apiService: ApiService, 
    private storage: StorageService, 
    public router: Router,
    public authService: AuthService,
    private snackBar: MatSnackBar,) { }

  register() {
    if (this.registerForm.valid) {
      this.isLoading = true;
      const details = {
        'name': this.registerForm.value.name,
        'email': this.registerForm.value.email,
        'phone': this.registerForm.value.phone,
        'password': this.registerForm.value.password,
        'confirmpassword': this.registerForm.value.confirmPassword
      };
      this.apiService.register(details).then((response: any) => {
        if (response.success === true) {
          let data = response;
          this.isLoading = false;
          this.storage.set('user_id', data.data.id);
          this.storage.set('token', data.data.token);
          this.storage.set('user_data', JSON.stringify(data));
          this.authService.isAuthenticated.next(true);
          this.router.navigateByUrl('/dashboard', { replaceUrl: true });
        }else{
          this.isLoading = false;
          this.errors = response.messages;
        }
      }).catch((error: any) => {
        this.isLoading = false;
        this.errors = error.error?.message || 'An error occurred. Please try again.';
      });
    }
  }

  // Custom validator to check that two fields match
  passwordMatchValidator(g: FormGroup) {
    return g.get('password')?.value === g.get('confirmPassword')?.value
      ? null : { mismatch: true };
  }

  goToLogin() {
    this.apiService.isLogin.next(true);
  }

  ngOnInit(): void {
    
  }

}
